/* Deskon - the opening and closing of an accordion row.

   Free delivery / Love it or return it / Contact us, and every other row built from
   blocks/_accordion-row.liquid.

   ================================================================================================
   WHAT THIS REPLACES, AND WHY THE OLD ONE COULD NOT WORK
   ================================================================================================
   The previous version measured: it set details.open, read content.scrollHeight, and animated an
   inline max-height between the two numbers. Two things were wrong with that.

   1. The number is read at the one moment it cannot be trusted. The panel has only just been
      revealed, the layout for it may not have been computed yet, and scrollHeight can come back 0.
      Animating 0 -> 0 fires no transitionend, so the safety timeout cleared the inline style and
      the panel popped open. That is why it was intermittent, why it only ever affected OPENING,
      and why it happened on desktop too - it was never a mobile or a WebKit problem.

   2. It fought the CSS. assets/deskon-accordion-chevron.css was already collapsing the same
      element with a grid track, and the old stylesheet had to switch that off with
      "transition: none !important" for the max-height to be visible. Two mechanisms on one box.

   NOTHING IS MEASURED HERE. assets/deskon-accordion-open.css animates a grid row from 0fr to 1fr,
   which needs no numbers at all. This file only decides WHEN, and it does it the same way
   assets/faq-accordion.js does - the accordion on this site that has always been smooth.

   ------------------------------------------------------------------------------------------------
   THE TWO FRAMES ARE THE WHOLE POINT. DO NOT COLLAPSE THEM INTO ONE.
   ------------------------------------------------------------------------------------------------
   A transition only runs if the browser has already painted a "before" value. A panel inside a
   shut <details> is not rendered, so at the instant the row opens there is nothing to transition
   from. Opening the row and then waiting two animation frames gives the browser one frame to lay
   the panel out at 0fr and one to paint it; the class that changes the value is added only after
   that. It is the same double rAF as faq-accordion.js, for the same reason.

   ------------------------------------------------------------------------------------------------
   CLOSING KEEPS THE ROW [open] UNTIL THE ANIMATION ENDS
   ------------------------------------------------------------------------------------------------
   Dropping the attribute first would un-render the panel immediately and there would be no closing
   animation at all. The chevron would then turn back late, so the row is marked .dk-closing and the
   stylesheet turns the mark back on time. See the note at the foot of the CSS.

   ------------------------------------------------------------------------------------------------
   IT NEVER TAKES OVER A ROW IT HAS NOT CHECKED
   ------------------------------------------------------------------------------------------------
   ready() requires exactly the markup blocks/_accordion-row.liquid emits: a <details> that is the
   host's own child, whose panel is .details-content, whose only child is .details-content__inner.
   .details-content is also the class of the footer menu and the mobile nav drawer, and those do
   not have that wrapper - so they are left entirely alone. If any check fails the host never gets
   .dk-acc, not one CSS rule below matches, and the row keeps the theme's native behaviour.
   A single grid row is declared, so a second child would land in an implicit auto row and never
   collapse; that is why the count is checked rather than assumed.

   ------------------------------------------------------------------------------------------------
   THE OBSERVER IS NOT OPTIONAL
   ------------------------------------------------------------------------------------------------
   assets/accordion-custom.js sets details.open directly - on connect, and again on every crossing
   of the 750px breakpoint (#setDefaultOpenState). Those changes come with no click, so the panel
   would be left collapsed under an open row. The MutationObserver mirrors them instantly, without
   animating, because they are not user gestures.

   The guard against the observer reacting to this file's OWN writes is a flag cleared from a
   setTimeout rather than immediately: observer callbacks are delivered as a microtask, which
   always runs before a timeout, so the flag is still up when the callback arrives and down before
   anything else can happen. Clearing it on the next line would not work. */

(function () {
  'use strict';

  var HOST = 'ACCORDION-CUSTOM';
  var READY = 'dk-acc';
  var OPEN = 'dk-open';
  var CLOSING = 'dk-closing';

  function panelOf(details) {
    var kids = details.children;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].classList && kids[i].classList.contains('details-content')) return kids[i];
    }
    return null;
  }

  /* The markup contract. See the note above - a row that does not match is left native. */
  function ready(host) {
    if (!host || host.nodeName !== HOST) return null;
    var details = host.querySelector('details');
    if (!details || details.parentElement !== host) return null;
    var panel = panelOf(details);
    if (!panel) return null;
    if (panel.children.length !== 1) return null;
    var inner = panel.firstElementChild;
    if (!inner || !inner.classList.contains('details-content__inner')) return null;
    return { host: host, details: details, panel: panel };
  }

  function reduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* The transition's own duration, read back rather than repeated here, so the stylesheet stays
     the only place the number lives. Used for the safety net, never for the animation itself. */
  function durationMs(el) {
    var raw = window.getComputedStyle(el).transitionDuration || '0s';
    raw = raw.split(',')[0].trim();
    var n = parseFloat(raw) || 0;
    return raw.indexOf('ms') !== -1 ? n : n * 1000;
  }

  function stop(row) {
    if (row.raf1) {
      cancelAnimationFrame(row.raf1);
      row.raf1 = 0;
    }
    if (row.raf2) {
      cancelAnimationFrame(row.raf2);
      row.raf2 = 0;
    }
    if (row.timer) {
      clearTimeout(row.timer);
      row.timer = 0;
    }
    if (row.onEnd) {
      row.panel.removeEventListener('transitionend', row.onEnd);
      row.onEnd = null;
    }
  }

  function setOpen(row, value) {
    row.internal = true;
    row.details.open = value;
    setTimeout(function () {
      row.internal = false;
    }, 0);
  }

  /* Mirror the row's current state with no animation at all. Used on first sight and for every
     change this file did not make. */
  function sync(row) {
    stop(row);
    row.details.classList.remove(CLOSING);
    row.panel.style.transition = 'none';
    if (row.details.open) row.panel.classList.add(OPEN);
    else row.panel.classList.remove(OPEN);
    void row.panel.offsetHeight;
    row.panel.style.transition = '';
  }

  function open(row) {
    stop(row);
    row.details.classList.remove(CLOSING);
    setOpen(row, true);

    if (reduced()) {
      row.panel.classList.add(OPEN);
      return;
    }

    row.raf1 = requestAnimationFrame(function () {
      row.raf1 = 0;
      row.raf2 = requestAnimationFrame(function () {
        row.raf2 = 0;
        row.panel.classList.add(OPEN);
      });
    });
  }

  function close(row) {
    stop(row);
    row.panel.classList.remove(OPEN);

    if (reduced()) {
      setOpen(row, false);
      return;
    }

    row.details.classList.add(CLOSING);

    var settle = function () {
      stop(row);
      row.details.classList.remove(CLOSING);
      setOpen(row, false);
    };

    row.onEnd = function (event) {
      if (event.target !== row.panel || event.propertyName !== 'grid-template-rows') return;
      settle();
    };

    row.panel.addEventListener('transitionend', row.onEnd);
    row.timer = setTimeout(settle, durationMs(row.panel) + 80);
  }

  function init(host) {
    if (host.dkRow) return host.dkRow;
    var row = ready(host);
    if (!row) return null;

    host.dkRow = row;
    host.classList.add(READY);
    sync(row);

    if (window.MutationObserver) {
      new MutationObserver(function () {
        if (row.internal) return;
        sync(row);
      }).observe(row.details, { attributes: true, attributeFilter: ['open'] });
    }

    return row;
  }

  function scan(root) {
    var list = (root || document).querySelectorAll('accordion-custom');
    for (var i = 0; i < list.length; i++) init(list[i]);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var summary = target.closest('summary');
    if (!summary) return;

    var details = summary.parentElement;
    if (!details || details.nodeName !== 'DETAILS') return;

    var host = details.parentElement;
    if (!host || host.nodeName !== HOST) return;

    /* accordion-custom cancels the toggle itself at the breakpoints where a row is meant to stay
       put (data-disable-on-mobile / data-disable-on-desktop). Its listener is on the summary, so
       it has already run by the time the event reaches here - respect its decision. */
    if (event.defaultPrevented) return;

    var row = init(host);
    if (!row || row.details !== details) return;

    event.preventDefault();

    if (row.details.open && !row.details.classList.contains(CLOSING)) close(row);
    else open(row);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  /* The theme editor replaces a whole section's markup; the rows inside it are new elements. */
  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target || document);
  });
})();
